import { Injectable } from '@angular/core';
import { AbstractService } from "../common/abstract.service";
import { HttpClient } from "@angular/common/http";
import { ThemeType } from "../../../core/enum/theme-type";
import { ServiceErrorHandler } from '../../../decorator/service-error-handler-decorator';
import { tap } from 'rxjs/operators';
import { PubsubService } from './pubsub.service';
const ThemeApi = {
  themeissues: "themeissues/crud",
  stakeholdertypes: "stakeholders-types/crud",
  complaintthemes: "complaintthemes/crud",
  themedecisions: "themedecisions/crud",
  phases: "phases/crud",
  interests: "interests/crud",
  themetype: "",
  permitstypes: "types/crud?group=permitstypes",
  permitsrequesters: "types/crud?group=permitsrequesters",
  permitsclusters: "types/crud?group=permitsclusters",
  permitsvalidities: "types/crud?group=permitsvalidities",
  permitsfillingrequirements: "types/crud?group=permitsfillingrequirements"
}
@Injectable({
  providedIn: 'root'
})
export class ThemesService extends AbstractService {

  constructor(private http: HttpClient, private pubsub: PubsubService) {
    super();
  }

  @ServiceErrorHandler()
  getThemes(type: ThemeType) {
    if (type && type.includes('permits')) {
      return this.http.get(`/api/types?group=${type}`, this.httpOptions)
    }
    return this.http.get(`/api/${type}`, this.httpOptions)
  }

  @ServiceErrorHandler()
  submitTheme(type, names: any, options?: { sourceUniqueId?: string }) {
    return this.http.post(`/api/${ThemeApi[type]}`, names, this.httpOptions)
      .pipe(tap(response => {
        if (options?.sourceUniqueId) {
          this.pubsub.createdThemeType.next({ type, response, payload: names, sourceUniqueId: options.sourceUniqueId });
        }
      }));
  }

  @ServiceErrorHandler()
  updateTheme(type: ThemeType, themes, options?: { sourceUniqueId?: string }) {
    let url = ""
    if (type.indexOf("?") > -1) {
      url = type.replace("types", "types/crud")
    }
    else {
      url = ThemeApi[type]
    }
    return this.http.post(`/api/${url}`, themes, this.httpOptions)
      .pipe(tap(response => {
        if (options?.sourceUniqueId) {
          this.pubsub.createdThemeType.next({ type, response, payload: themes, sourceUniqueId: options.sourceUniqueId });
        }
      }));
  }

  @ServiceErrorHandler()
  deleteTheme(type: ThemeType, themes) {
    return this.http.post(`/api/${ThemeApi[type]}`, themes, this.httpOptions);
  }
}
